import React from 'react';
interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
  /** Render the label at question-heading size instead of the smaller helper size */
  prominentLabel?: boolean;
}
export function TextArea({
  label,
  id,
  prominentLabel,
  ...props
}: TextAreaProps) {
  return <div className="flex flex-col gap-2" data-id="element-26" data-mp="1aavojh81z3l1">
      <label htmlFor={id} className={prominentLabel ? 'text-[#0b2a4a] font-semibold text-sm md:text-base' : 'text-[#0b2a4a] font-medium text-sm'} data-id="element-27" data-mp="1aa3uwby0nfxe">
        {label}
      </label>
      <textarea id={id} className="w-full min-h-[64px] p-3 rounded-md border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:border-[#14b8a6] focus:ring-1 focus:ring-[#14b8a6] transition-shadow resize-y" {...props} data-id="element-28" data-mp="1y1spjyyb8ghi" />
    </div>;
}